import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-table-cloneable', 'addRow', 'Добавить строку');
Labels.set('ui-table-cloneable', 'removeRow', 'Удалить строку');
